import { Component, createRef } from "react"

/* Components */
import { DataLayout, Icon } from "../../components"

/* Widgets */
import { AdminForm } from "../../widgets/admin"
import { toast, confirm } from "../../widgets/common"

/* Shared */
import { initialsOf, avatarColorOf, ago } from "../../widgets/user/shared"
import { plural } from "../../widgets/category/shared"

/* REST API */
import { list, remove } from "../../api/Admin"

/* Moment */
import moment from "moment"


/* Page Admins — the people who work in this panel. There are a few of them, so they stand as cards.
   Nobody removes himself and nobody removes the last one — the panel would stay without a door */
class Admins extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: []
        }

        this._form = createRef()
    }

    componentDidMount = () => {

        window.scrollTo(0, 0)
        this.load(true)
    }

    load = (reload = false) => {

        if (reload) {
            this.setState({ status: "loading" })
        }

        list({}).then(response => {
            if (response && response.status === 200) {
                this.setState({ status: "ok", data: response.data.list })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    remove = item => {

        confirm({
            title: `Удалить ${item.name ? item.name : "администратора"}?`,
            text: "Войти в админку с этой почтой больше не получится. Работа, которую он сделал, останется",
            confirmText: "Да, удалить",
            cancelText: "Нет",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            remove({ id: item.id }).then(response => {

                if (response && response.status === 200) {
                    toast.success("Администратор удалён")
                    this.load()
                    return
                }

                if (response && response.data && response.data.code === "LAST_ADMIN") {
                    toast.error("Последнего администратора удалить нельзя")
                    return
                }

                toast.error("Что-то пошло не так! Попробуйте позднее")
            }).catch(() => toast.error("Что-то пошло не так! Попробуйте позднее"))
        })
    }

    _header = () => {
        return (
            <div className="organization-header">

                <div className="page-header-text">Администраторы</div>

                <div className="organization-header-tools">
                    <div onClick={() => this._form.current.open()} className="organization-create">
                        <Icon name="plus" size={17} width={2.4} />
                        <span>Добавить</span>
                    </div>
                </div>

            </div>
        )
    }

    /* The state of the team in one line */
    _intro = () => {

        /* Fields */
        const { data } = this.state

        const week = data.filter(item => item.lastLoginAt && moment(item.lastLoginAt).isAfter(moment().subtract(7, "days"))).length
        const resolved = data.reduce((sum, item) => sum + item.resolved, 0)

        return (
            <div className="admin-intro">
                <div className="admin-intro-icon"><Icon name="shield" size={24} width={1.9} /></div>
                <div className="admin-intro-text">
                    <b>{data.length} {plural(data.length, "администратор", "администратора", "администраторов")} · у всех полный доступ</b>
                    <span>Роли и права по разделам появятся отдельно — тогда здесь будет видно, кто что может</span>
                </div>
                <div className="admin-intro-numbers">
                    <div><b>{week}</b><span>входили за неделю</span></div>
                    <div><b>{resolved}</b><span>закрыли обращений</span></div>
                </div>
            </div>
        )
    }

    /* One administrator */
    _card = item => {

        const name = item.name && `${item.name}`.trim().length > 0 ? `${item.name}`.trim() : "Без имени"
        const recent = item.lastLoginAt && moment(item.lastLoginAt).isAfter(moment().subtract(1, "day"))

        return (
            <div key={`${item.id}`} className={`admin-card ${item.me ? "me" : ""}`} style={{ "--avatar": avatarColorOf(item.id) }}>

                <div className="admin-card-top">
                    <div className="admin-card-avatar">
                        <span>{initialsOf(name)}</span>
                        {recent && <i title="Входил за последние сутки" />}
                    </div>
                    {item.me && <div className="user-badge blue">Это вы</div>}
                </div>

                <div className="admin-card-name">{name}</div>
                <div className="admin-card-email">{item.email}</div>

                <div className="admin-card-facts">
                    <div>
                        <span>Последний вход</span>
                        <b>{item.lastLoginAt ? ago(item.lastLoginAt) : "ещё не отмечен"}</b>
                    </div>
                    <div>
                        <span>Закрыл обращений</span>
                        <b>{item.resolved}{item.lastResolvedAt ? ` · ${ago(item.lastResolvedAt)}` : ""}</b>
                    </div>
                    <div>
                        <span>В админке с</span>
                        <b>{moment(item.createdAt).format("D MMMM YYYY")}</b>
                    </div>
                </div>

                <div className="admin-card-actions">
                    <div onClick={() => this._form.current.open(item)} className="admin-card-button">
                        <Icon name="edit" size={15} width={2} />
                        Изменить
                    </div>
                    {!item.me &&
                        <div onClick={() => this.remove(item)} className="admin-card-button danger" title="Удалить">
                            <Icon name="trash" size={15} width={2} />
                        </div>
                    }
                </div>

            </div>
        )
    }

    _content = () => {

        /* Fields */
        const { status, data } = this.state

        if (status !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    <DataLayout status={status} reload={() => this.load(true)} data={data} />
                </div>
            )
        }

        return (
            <div className="page-content">

                {this._intro()}

                <div className="admin-grid">

                    {data.map(item => this._card(item))}

                    <div onClick={() => this._form.current.open()} className="admin-card add">
                        <div className="admin-add-icon"><Icon name="plus" size={22} width={2.2} /></div>
                        <b>Новый администратор</b>
                        <span>Имя, почта и пароль — и он может войти</span>
                    </div>

                </div>

            </div>
        )
    }

    render = () => {
        return (
            <div className="page">

                {this._header()}

                {this._content()}

                <AdminForm ref={this._form} onSaved={() => this.load()} />

            </div>
        )
    }
}

export default Admins
